import React from 'react'
import { IDetailCellRendererParams } from 'ag-grid-enterprise'
import { Alert, Descriptions } from 'antd'
import { useTranslation } from 'react-i18next'
import { parseDate } from '../../../config/dayjsConfig'
import { Match } from '../types'
import { buildCounterpartyGroups, getReference, isAccepted, isAcceptanceStale } from '../utils/reconciliationHelpers'
import { ReconciliationGridContext } from './reconciliationCellRenderers'
import ReconciliationVoucherGroups from './ReconciliationVoucherGroups'

const formatDateTime = (value?: string) => (value ? parseDate(value)?.format('DD.MM.YYYY HH:mm') ?? value : value)

const AcceptanceInfo: React.FC<{ match: Match; userNameById: Map<number, string> }> = ({ match, userNameById }) => {
  const { t } = useTranslation()

  if (isAcceptanceStale(match)) {
    return (
      <Alert
        type="warning"
        showIcon
        style={{ marginBottom: 12 }}
        message={t('icReconciliation:staleTag', 'Hyväksyntä vanhentunut')}
        description={t('icReconciliation:staleTooltip', 'Tiedot muuttuivat hyväksynnän jälkeen — käsittele uudelleen')}
      />
    )
  }

  if (!isAccepted(match) || !match.accepted) return null

  const { acceptedBy, acceptedByEmail, acceptedAt, comment } = match.accepted
  const acceptedByName = (acceptedBy != null && userNameById.get(acceptedBy)) || acceptedByEmail
  return (
    <Descriptions
      size="small"
      column={1}
      style={{ marginBottom: 12 }}
      items={[
        {
          key: 'by',
          label: t('icReconciliation:acceptedBy', 'Hyväksynyt'),
          children: acceptedByName ?? '—'
        },
        {
          key: 'at',
          label: t('icReconciliation:acceptedAt', 'Hyväksytty'),
          children: formatDateTime(acceptedAt) ?? '—'
        },
        {
          key: 'comment',
          label: t('icReconciliation:acceptedComment', 'Perustelu'),
          children: comment || '—'
        }
      ]}
    />
  )
}

const ReconciliationDetailPanel: React.FC<IDetailCellRendererParams<Match>> = ({ data, context }) => {
  const gridContext = context as ReconciliationGridContext | undefined

  return (
    <div style={{ paddingInline: 16 }}>
      {data && <AcceptanceInfo match={data} userNameById={gridContext?.userNameById ?? new Map()} />}
      <ReconciliationVoucherGroups
        groups={data && gridContext ? buildCounterpartyGroups(data, gridContext.companyNameById) : []}
        reference={data ? getReference(data) : undefined}
      />
    </div>
  )
}

export default ReconciliationDetailPanel
